import { prefixLink } from '@ms/config/app'

// 自定义 history back 方法
window.goBack = () => {
  console.log(document.referrer, history.length)
  if (document.referrer.search(location.hostname) === -1 || history.length < 1 || window.opener) {
    location.href = prefixLink()
  } else {
    // location.href = document.referrer
    history.back()
  }
}
